import { styled, css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const CellContainer = styled(Flex)`
    align-items: center;
    gap: 8px;
    height: 100%;
    cursor: pointer;
`;

export const ColorContainer = styled.div<{ color: string }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;

    ${({ color }) => css`
        background-color: ${color};
    `};
`;

export const TextContainer = styled(Flex)<{ isPrimary?: boolean }>`
    ${setFontVariant("subtitle2", colorsPalettes.blue[400])};
    gap: 5px;

    ${({ isPrimary }) => (isPrimary ? "font-weight: 700;" : "font-weight: 400;")}
`;
